import Axios from 'axios';
import { toast } from 'react-toastify';

const API_URL = process.env.REACT_APP_API_URL;

const authHeader = () => {
    const token = localStorage.getItem('token');
    return { headers: { Authorization: token } };
};

export const fetchKendras = async (labId, setKendras) => {
    try {
        let url = `${API_URL}/kendras/fetchKendras`;
        if (labId) url += `?lab_id=${labId}`;
        const res = await Axios.get(url, authHeader());
        if (res.data.status === 'success') {
            setKendras(res.data.data);
        }
    } catch (err) {
        console.error(err);
        toast.error('Failed to fetch kendras');
    }
};

export const saveKendra = async (formData, setKendras, clearForm) => {
    try {
        const res = await Axios.post(`${API_URL}/kendras/addKendra`, formData, authHeader());
        if (res.data.status === 'success') {
            toast.success('Kendra added successfully');
            if (clearForm) clearForm();
            fetchKendras(formData.lab_id, setKendras);
        } else {
            toast.error(res.data.message || 'Failed to add kendra');
        }
    } catch (err) {
        console.error(err);
        toast.error('Failed to save kendra');
    }
};

export const deleteKendra = async (id, labId, setKendras) => {
    if (!window.confirm("Are you sure you want to delete this kendra?")) return;
    try {
        const res = await Axios.delete(`${API_URL}/kendras/deleteKendra/${id}`, authHeader());
        if (res.data.status === 'success') {
            toast.success('Kendra deleted');
            fetchKendras(labId, setKendras);
        }
    } catch (err) {
        console.error(err);
        toast.error('Failed to delete kendra');
    }
};
